import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getNodeByKey } from "lexical";
import { toPairs } from "lodash-es";
import { useEffect } from "react";
import { useFlag } from "../../../../server/optimizely";
import { $createButtonListNode, ButtonListNodeMui } from "../nodes/button-list-mui";
import { $isButtonListNode } from "../nodes/button-list-node";
import type { InsertButtonListCommand } from "../types/commands";
import { INSERT_BUTTON_LIST_COMMAND } from "../types/commands";
import { $insertNode } from "../utils/insert-node";
import { $selectionOrStart } from "../utils/selection-or-start";

export function ButtonListPlugin(): null {
  const [editor] = useLexicalComposerContext();
  const [editor_focus_fix] = useFlag("cha_4472_editor_focus_fix_for_links_and_surveys");

  useEffect(
    () =>
      editor.registerCommand(
        INSERT_BUTTON_LIST_COMMAND,
        (data: InsertButtonListCommand) => {
          // Without a caret Lexical's $insertNodes falls back to the end of the document.
          if (editor_focus_fix) $selectionOrStart();
          $insertNode($createButtonListNode(editor._headless, data.buttons));

          return true;
        },
        1,
      ),
    [editor, editor_focus_fix],
  );

  useEffect(() => {
    return editor.registerMutationListener(ButtonListNodeMui, (mutatedNodes) => {
      toPairs(mutatedNodes).map(([key, mutation]) => {
        if (mutation !== "destroyed") {
          editor.update(() => {
            const node = $getNodeByKey(key);
            if (!node) return;
            if (!$isButtonListNode(node)) return;

            if (node.__buttons.length === 0) {
              node.remove();
            }
          });
        }
      });
    });
  }, [editor]);

  return null;
}
